import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const items = [
  { to: '/profile', labelKey: 'profile', end: true },
  { to: '/profile/orders', labelKey: 'My Orders' },
  { to: '/profile/manage-address', labelKey: 'Manage addresses' },
  { to: '/profile/change-language', labelKey: 'Change language' },
];

const ProfileMobileSubNav = () => {
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t('Profile navigation', { defaultValue: 'Profile navigation' })}
      className="lg:hidden sticky top-14 z-20 bg-white border-b border-gray-200 overflow-x-auto scrollbar-hide"
    >
      <ul className="flex items-stretch gap-2 px-4 py-2 whitespace-nowrap">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `inline-flex items-center px-4 min-h-[44px] rounded-full text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-[#04B7DF] text-white'
                    : 'bg-[#f3f3f4] text-[#000000DE] hover:bg-[#e6e6e6]'
                }`
              }
            >
              {t(item.labelKey)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ProfileMobileSubNav;
